<script lang="ts" setup></script>

<template>
  <div class="w-full container mx-auto">
    <slot />
  </div>
</template>
